module.exports = __webpack_public_path__ + "static/4-885e88ee527d4309d701bb8962d6f99d.png";